/**
 * 日期格式转换
 * @param {String} time 时间戳
 * @param {String} format 日期格式 例：Y-m-d h:i:s
 * Y-m-d h:i:s 转换为2021-09-01 12:30:30
 * m-d h:i:s 转换为09-01 12:30:30
 * m-d h:i 转换为09-01 12:30
 * Y年m月d日h时i分s秒 转换为2021年09月01日12时30分30秒
*/
export const timeStamp2String = (time:number, format:string) => {
	const dateTime = new Date()
	dateTime.setTime(time)
	if (time.toString().length == 10) {
		dateTime.setTime(time * 1000)
	}
	const year = dateTime.getFullYear()
	const month = dateTime.getMonth() + 1 < 10 ? '0' + (dateTime.getMonth() + 1) : dateTime.getMonth() + 1
	const date = dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate()
	const hour = dateTime.getHours() < 10 ? '0' + dateTime.getHours() : dateTime.getHours()
	const minute = dateTime.getMinutes() < 10 ? '0' + dateTime.getMinutes() : dateTime.getMinutes()
	const second = dateTime.getSeconds() < 10 ? '0' + dateTime.getSeconds() : dateTime.getSeconds()
	// 返回字符串格式
	let dateInfo = ''
	const yIndex = format.search('Y')
	const mIndex = format.search('m')
	const dIndex = format.search('d')
	const hIndex = format.search('h')
	const iIndex = format.search('i')
	const sIndex = format.search('s')
	dateInfo += `${str(year, yIndex)}`
	dateInfo += `${str(month, mIndex)}`
	dateInfo += `${str(date, dIndex)}`
	dateInfo += `${str(hour, hIndex)}`
	dateInfo += `${str(minute, iIndex)}`
	dateInfo += `${str(second, sIndex)}`
	return dateInfo
	function str(number:any, index:number) {
		if (index > -1) return `${number}${format.slice(index + 1, index + 2)}`
		else return ''
	}
}

// 判断是否为微信浏览器
export function isWxBrowser() {
	let ua = navigator.userAgent.toLowerCase();
	return /micromessenger/.test(ua) ? true : false;
}

// 获取地址栏参数
export function getUrlParam(name:string) {
	// 获取参数
	var url = window.location.search;
	// 正则筛选地址栏
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	// 匹配目标参数
	var result = url.substr(1).match(reg);
	//返回参数值
	return result ? decodeURIComponent(result[2]) : null;
}
